import React, { useContext, useEffect, useMemo, useState } from "react";
import SelectControl from "../SelecControl/SelectControl";
import { estructuraLectura, unidadesMedidasOpciones } from "../../utils/estructuras";

import {getDifferenceInDays} from '../../utils/funciones';

// Alertas
import Swal from 'sweetalert2'
import moment from "moment";
import authContext from "../../context/authentication/authContex";

                                
const ModalFormLectura = ({activo,usuario,index,minimizar,getLastLecturaByUnidadAndActivo,addLectura,getLectsByActivoId, calcularMantenimientoByActivo, componentePadre="", firstRender=true, fechaCompletado="", uniMedToAsk = null, title}) => {

    const [newLectura,setNewLectura] = useState({...estructuraLectura, uniMed: uniMedToAsk ?? activo.DEFAULTUNIMED, fecha: fechaCompletado != '' ? fechaCompletado : moment().utcOffset(-3).format('YYYY-MM-DD HH:mm:ss'), activoID:activo._id,codActivo:activo.codActivo,comUserID:usuario._id,userName:usuario.userName});
    const [lastLectura,setLastLectura] = useState(undefined);
    const [lecturasByActivoAndUnimed,setLecturasByActivoAndUnimed] = useState([]);
    const [disableSave,setDisableSave] = useState(false);
    const {getValorActualFromDictionary} = useContext(authContext);

    const handleChange = async(e, i, prop='', value='') => {
        let newLec = {...newLectura};
        let valorCorreccion = 0;
        if(prop != '' && value != ''){
            if(prop == 'uniMed'){
                let resLastLect;
                let valorAux;
                //Si se setea la unidad de medida a la default (primaria o secundaria) del activo, automaticamente se suma el valorCorrectivo.
                if(value.value == activo.DEFAULTUNIMED.value){
                    valorCorreccion = (activo.ajusteLecturas != undefined) ? activo.ajusteLecturas : 0;
                    valorAux = Number.parseInt(newLec.valorAajustar) + valorCorreccion;
                }else if(activo.DEFAULTUNIMED2?.value && value.value == activo.DEFAULTUNIMED2.value){
                    valorCorreccion = (activo.ajusteLecturas2 != undefined) ? activo.ajusteLecturas2 : 0;
                    valorAux = Number.parseInt(newLec.valorAajustar) + valorCorreccion;
                }else{
                    valorAux = Number.parseInt(newLec.valorAajustar);
                }
                newLec["valor"] = valorAux;
                resLastLect = await getLastLecturaByUnidadAndActivo(activo._id,value.value);
                let resLects =  await getLectsByActivoId(activo._id, value.value);
                setLecturasByActivoAndUnimed(resLects.lecturas);
                if(resLastLect.encontrado) setLastLectura(resLastLect.lastLect.valor);
                else setLastLectura(0);
            } 
            newLec[prop] = value;
        }else{
            if(e.target.name == "valorAajustar"){
                let valorAux = Number.parseFloat(e.target.value);
                if(newLectura.uniMed.value == activo.DEFAULTUNIMED.value) valorCorreccion = (activo.ajusteLecturas != undefined) ? activo.ajusteLecturas : 0;
                else if(activo.DEFAULTUNIMED2?.value && newLectura.uniMed.value == activo.DEFAULTUNIMED2.value) valorCorreccion = (activo.ajusteLecturas2 != undefined) ? activo.ajusteLecturas2 : 0;
                valorAux = valorAux + valorCorreccion;
                newLec["valor"] = valorAux;
            }
            let {name,value} = e.target;
            newLec[name] = value;
        }
        setNewLectura(newLec);
    }

    const validate = (smallerChecked = false, masiveChecked = false) =>{
        let lengthLecturas = lecturasByActivoAndUnimed.length; 
        if(newLectura.valor <= lastLectura && !smallerChecked){
            return {msg:`Valor nueva lectura ${newLectura.valor} es menor o igual que valor última lectura ${lastLectura}.\n Está seguro que desea guardar la nueva lectura?`, smallerChecked:false, masiveChecked:masiveChecked} 
        }
        if(newLectura.cargaMasiva.value != null && !masiveChecked){
            return {msg:`Está seguro que desea realizar una Carga Masiva!!!???`, smallerChecked: true, masiveChecked:false}; 
        }
        if(lengthLecturas > 1){
            //Vienen ordenadas de mas nueva a mas vieja, por lo la ultima en orden descendente seria la primera.
            let difUltimaAndAnteultima = lecturasByActivoAndUnimed[0].valor - lecturasByActivoAndUnimed[1].valor;
            let difDiasUltimaAndAnteultima = getDifferenceInDays(new Date(lecturasByActivoAndUnimed[0].fecha.substring(0,10)),new Date(lecturasByActivoAndUnimed[1].fecha.substring(0,10)));
            //Si diferencia en dias entre Ultima y Anteultima es mayor a 0 continua la validacion, caso contrario lo deja pasar.
            if( difDiasUltimaAndAnteultima > 0){
                let primerIncrementoDiario = difUltimaAndAnteultima / difDiasUltimaAndAnteultima;
                let difNuevaAndUltima = newLectura.valor - lecturasByActivoAndUnimed[0].valor;
                let difDiasNuevaAndUltima = getDifferenceInDays(new Date(newLectura.fecha.substring(0,10)),new Date(lecturasByActivoAndUnimed[0].fecha.substring(0,10)));
                let segundoIncrementoDiario = difNuevaAndUltima / difDiasNuevaAndUltima;
                let promedioIncrementoDiario = Math.abs(((segundoIncrementoDiario - primerIncrementoDiario) / primerIncrementoDiario) * 100);
                
                if(promedioIncrementoDiario > 80){
                    return {msg:`LECTURA FUERA DE LO NORMAL: el promedio de Incremento Diario para la unidad de medida ${newLectura.uniMed.value} según la nueva lectura difiere en más del 80% con el último promedio de incremento diario calculado.\n Está seguro que desea guardar la nueva lectura?`,smallerChecked: true, masiveChecked: true}
                }else{
                    return {msg:''};
                }
            }else{
                return {msg:''};
            }
        }else{
            return {msg:''};
        }
        
    }

    const addNewLectura = async() => {
        setDisableSave(true);
        let lectToSave = {...newLectura, lastLecturaValor: lastLectura};
        const res = await addLectura(lectToSave);
        if(res.uploadedLect != undefined && res.uploadedLect.activoID != undefined){
            await calcularMantenimientoByActivo(activo);
            minimizar(true, (firstRender) ? '' : 'close');
            (componentePadre == "") ? Swal.fire({
                title: `Lectura registrada!`,
                icon: 'success',
                text: `La lectura para el activo ${activo.name} se guardo correctamente!`,//${resp.tDocNroFor}
                showConfirmButton: true,
                allowEnterKey: true
            }) : (componentePadre == 'RRActivo') && Swal.fire({
                title: `Lectura registrada!`,
                icon: 'success',
                text: `La lectura para el activo ${activo.name} se guardo correctamente y se procedera a finalizar el checklist!`,
                showConfirmButton: true,
                allowEnterKey: true
            })
        }else{
            if(res.response?.data?.message?.includes("Path `valor`"))
            Swal.fire({
                title: `Valor Lectura Incompleto!`,
                icon: 'error',
                text: `El valor de la nueva lectura debe ser mayor a 0!`,//${resp.tDocNroFor}
                showConfirmButton: true,
                allowEnterKey: true
            });
            else if(res)
            Swal.fire({
                title: `Algo no funciono segun lo esperado!`,
                icon: 'error',
                text: `Hubo un inconveniente desconocido, reporteselo a consultoria!`,//${resp.tDocNroFor}
                showConfirmButton: true,
                allowEnterKey: true
            });
            setDisableSave(false);
        } 
    }

    const handleAddLectura = async(smallerChecked = false, masiveChecked = false) => {
        const validation = validate(smallerChecked, masiveChecked);
        if(validation.msg == undefined || validation.msg == ''){
            await addNewLectura();
        }else{
            let result = await Swal.fire({
                title: `Ops!`,
                icon: 'warning',
                text: validation.msg,
                showConfirmButton: true,
                showCancelButton: true, // Habilita el botón de cancelar
                confirmButtonColor: '#ff0000',
                denyButtonColor: '#3d4d87',
                confirmButtonText: 'Sí, estoy seguro',
                cancelButtonText:'No',
                allowEnterKey: true
            })
            if (result.isConfirmed ) {           
                if(!validation.smallerChecked) await handleAddLectura(true);
                else if(validation.smallerChecked && !validation.masiveChecked) await handleAddLectura(true, true);
                else{
                    await addNewLectura();
                } 
            }
        }
    }

    const calculateLastLectura = async(activoId,uniMed) =>{
        let resLastLect;
        resLastLect = await getLastLecturaByUnidadAndActivo(activoId,uniMed);
        let resLects =  await getLectsByActivoId(activoId, uniMed);
        setLecturasByActivoAndUnimed(resLects.lecturas);
        if(resLastLect.encontrado) setLastLectura(resLastLect.lastLect.valor);
        else setLastLectura(0);
    }

    useEffect(()=>{
        calculateLastLectura(activo._id, uniMedToAsk?.value ?? activo.DEFAULTUNIMED.value);
    },[uniMedToAsk]);

    const cargaMasivaOpciones = useMemo(()=> {
        let options = [
            {value:"INCREMENTOLV1",label:`REPLICA INCREMENTO ACTIVOS MISMO ${getValorActualFromDictionary("Nivel 1").toUpperCase()}`},
            {value:"VALORLV1",label:`REPLICA VALOR ACTIVOS MISMO ${getValorActualFromDictionary("Nivel 1").toUpperCase()}`}
        ];

        if(activo.activoNivel2ID){
            options.push({value:"INCREMENTOLV2",label:`REPLICA INCREMENTO ACTIVOS MISMO ${getValorActualFromDictionary("Nivel 2").toUpperCase()}`})
            options.push({value:"VALORLV2",label:`REPLICA VALOR ACTIVOS MISMO ${getValorActualFromDictionary("Nivel 2").toUpperCase()}`})

            if(activo.activoNivel3ID){
                options.push({value:"INCREMENTOLV3",label:`REPLICA INCREMENTO ACTIVOS MISMO ${getValorActualFromDictionary("Nivel 3").toUpperCase()}`})
                options.push({value:"VALORLV3",label:`REPLICA VALOR ACTIVOS MISMO ${getValorActualFromDictionary("Nivel 3").toUpperCase()}`})
            }
        }

        options.push({value:null,label:`Sin carga masiva`});

        return options;
    }, [activo]);

    return <div className="modalFormDiv modalFormLecturaDiv">
        <button className="minimizarBtn" onClick={()=>minimizar(false,'close')}>X</button>
        <div className="headerModalForm">{title ?? 'Añadir Lectura'}</div>
        <div className="bodyModalForm">
            <div className="inputGroup">
                <label>Unidad de Medida</label>
                <SelectControl componentePadre={componentePadre} placeholder={"Seleccione una unidad de medida..."} modo='Nuevo' idSelect={"lecturas"} handleChengeSelect={handleChange} 
                optionsSelect={unidadesMedidasOpciones} 
                valueSeleccionada={newLectura.uniMed} tipo={'lecturas'} selectSelect={handleChange} index={index} setNuevoEditado={'Ninguno'} propToChange="uniMed"/>
            </div>
            <div className="inputGroup">
                <label>Carga Masiva</label>
                <SelectControl componentePadre={componentePadre} placeholder={"Sin carga masiva"} modo='Nuevo' idSelect={"lecturas"} handleChengeSelect={handleChange} optionsSelect={cargaMasivaOpciones} valueSeleccionada={newLectura.cargaMasiva} tipo={'lecturas'} selectSelect={handleChange} index={index} setNuevoEditado={'Ninguno'} propToChange="cargaMasiva"/>
            </div>
            <h6>{`Valor última lectura${(lastLectura != undefined) ? ' en ' + newLectura.uniMed.label + ': ' + lastLectura : ': '}`}</h6>
            <div className="lecturasInputsDiv">
                <div className="inputGroup">
                    <label>Valor Nueva Lectura</label>
                    <input name="valorAajustar" type="number" onChange={(e)=>handleChange(e,index)}/>
                </div>
                <div className="inputGroup">
                    <label>Ajustado</label>
                    <input disabled={true} value={newLectura.valor} name="valor" type="number" onChange={(e)=>handleChange(e,index)}/>
                </div>
            </div>
            <button className={`modalFormBtn ${(disableSave) ? 'disabledBtn' : ''}`} disabled={disableSave} onClick={()=>handleAddLectura()}>Guardar</button>
        </div>
    </div>

}

export default ModalFormLectura;